import { combineReducers } from 'redux'
import browser from './browser'
import router from './router'
import publications from './publications'
import posts from './posts'
import press from './press'
import events from './events'

const appReducer = combineReducers({
  browser,
  location: router,
  publications,
  posts,
  press,
  events,
})

export default appReducer
